import config from "@/config/config.json";
import {forceLogout} from "@/modules/api/auth";
import router from "@/router"

const apiErrorHandler = (promise, redirectedFrom)=>{

    const errorcode = promise.data.errorcode || promise.data.error_code;

    if (errorcode && errorcode !== "0") {

        if (errorcode === config.errorcode.invalid_token || errorcode === config.errorcode.invalid_token_proxy) {
            forceLogout(redirectedFrom);
            throw new Error(config.errorcode.invalid_token)
        } else {
            console.log(errorcode)
            throw new Error(config.errorcode.general)
        }
    }

}

export {apiErrorHandler}